import { Route } from "react-router-dom";

import { USER_TYPE } from "src/constants";
import { SUPERADMIN_ROUTES } from "src/pages/superadmin/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { AddEditAdmin } from "./AddEditAdmin.page";
import { AddEditCompany } from "./AddEditCompany.page";
import { AddEditPlan } from "./AddEditPlan.page";
import { Companies } from "./Companies.page";
import { SingleCompany } from "./SingleCompany.page";

/** Route tree for the super-admin companies module, mounted under `/companies`. */
export const superadminRoutes = (
  <Route path={SUPERADMIN_ROUTES.root}>
    <Route index element={<ProtectedRoute userType={USER_TYPE.SUPER_ADMIN} component={Companies} />} />
    <Route path={SUPERADMIN_ROUTES.details} element={<ProtectedRoute userType={USER_TYPE.SUPER_ADMIN} component={SingleCompany} />} />
    <Route
      path={SUPERADMIN_ROUTES.addAdmin}
      element={<ProtectedRoute userType={USER_TYPE.SUPER_ADMIN} component={AddEditAdmin} />}
    />
    <Route
      path={SUPERADMIN_ROUTES.editAdmin}
      element={<ProtectedRoute userType={USER_TYPE.SUPER_ADMIN} component={AddEditAdmin} />}
    />
    <Route
      path={SUPERADMIN_ROUTES.addPlan}
      element={<ProtectedRoute userType={USER_TYPE.SUPER_ADMIN} component={AddEditPlan} />}
    />
    <Route
      path={SUPERADMIN_ROUTES.editPlan}
      element={<ProtectedRoute userType={USER_TYPE.SUPER_ADMIN} component={AddEditPlan} />}
    />
    <Route path={SUPERADMIN_ROUTES.add} element={<ProtectedRoute userType={USER_TYPE.SUPER_ADMIN} component={AddEditCompany} />} />
    <Route
      path={SUPERADMIN_ROUTES.edit}
      element={<ProtectedRoute userType={USER_TYPE.SUPER_ADMIN} component={AddEditCompany} />}
    />
  </Route>
);
